import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { fontSize, fontWeight, lineHeight } from "../../../constants/typography";
import mediaQueries from "../../../util/mediaqueries";
import { NeutralColors } from "../../../constants/colors";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
export var SIZES = [1, 2];
export var DEFAULT_SIZE = 1;
var textSize1CSS = css(["font-size:", ";line-height:", ";", ""], fontSize.small, lineHeight.large, mediaQueries.lg(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n  "])), 0, 0, 0)), fontWeight.regular, fontSize.medium, lineHeight.medium));
var textSize2CSS = css(["font-weight:", ";font-size:", ";line-height:", ";", ""], fontWeight.regular, fontSize.medium, lineHeight.medium, mediaQueries.sm(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), 0, 0)), fontSize.large, lineHeight.small));
export var Text = styled.p.withConfig({
  componentId: "sc-1x8e85j-0"
})(["color:", ";font-style:normal;font-weight:normal;", ""], function (_ref) {
  var inverted = _ref.inverted;
  return inverted ? NeutralColors.White : NeutralColors.Ink;
}, function (props) {
  switch (props.size) {
    case 2:
      return textSize2CSS;
    default:
    case 1:
      return textSize1CSS;
  }
});
Text.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.string,
  size: PropTypes.oneOf(SIZES),
  inverted: PropTypes.bool
};
Text.defaultProps = {
  as: undefined,
  size: DEFAULT_SIZE,
  inverted: false
};